import uuid from 'node-uuid';
export const WEBINAR_USER_ID = 'webinarUserId';
export const G2S_ANONYMOUS_ID = 'g2sAnonymousId';

/**
 * Returns the cookie value from the decoded string of cookies if it exists, blank otherwise.
 * @param cookieName - Name of cookie to be found.
 * @returns {string}
 */
export function getCookie(cookieName) {
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    const matchingKeyValue = cookies.find((element) => {
        return cookieName === element.split('=')[0].trim();
    });
    return (matchingKeyValue) ? matchingKeyValue.split('=')[1] : '';
}

/**
 * Sets a cookie in the browser.
 * @param cookieName - Name of cookie to be set.
 * @param cookieValue - Value of the cookie.
 * @param expiryInMilliseconds - The expiry time to be set for the cookie. Set to 100 years if not defined.
 */
export function setCookie(cookieName, cookieValue, expiryInMilliseconds = 3.154e+12) {
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + expiryInMilliseconds);
    const expiresStr = `expires=${expiryDate.toUTCString()}`;
    document.cookie = `${cookieName}=${cookieValue};${expiresStr};path=/`;
}

/**
 * Returns the value of G2S_ANONYMOUS_ID cookie if it exists. If cookie doesn't exist, it creates the cookie.
 * @param oldCookieValue - if the cookie exists under the name WEBINAR_USER_ID,
 * then create a new cookie with the name G2S_ANONYMOUS_ID with the same cookie value
 * and delete the cookie with name WEBINAR_USER_ID
 */

export function getG2sAnonymousIdCookie() {
    const oldCookieValue = getCookie(WEBINAR_USER_ID);
    const newCookieValue = getCookie(G2S_ANONYMOUS_ID);
    if (oldCookieValue) {
        setCookie(G2S_ANONYMOUS_ID, oldCookieValue);
        setCookie(WEBINAR_USER_ID, '', 0);
        return oldCookieValue;
    } else if (newCookieValue) {
        return newCookieValue;
    }
    setCookie(G2S_ANONYMOUS_ID, uuid.v4());
    return getCookie(G2S_ANONYMOUS_ID);
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/CookieHelper.js